import React from 'react'
import Slider from 'react-slick'
import SbEditable from 'storyblok-react'
import Headline from '../atoms/Headline'
import Image from '../atoms/Image'
import Link from '../atoms/Link'

// TODO: get root-data + fix arrow-styling?

const HighlightsBlock = ({ block }) => {
  function NextArrow(props) {
    const { className, onClick } = props
    return (
      <span className={className} onClick={onClick}>
        <i className="fal fa-chevron-right"></i>
      </span>
    )
  }

  function PrevArrow(props) {
    const { className, onClick } = props
    return (
      <span className={className} onClick={onClick}>
        <i className="fal fa-chevron-left"></i>
      </span>
    )
  }

  const settings = {
    dots: true,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    prevArrow: <PrevArrow className="slick-prev" />,
    nextArrow: <NextArrow className="slick-next" />,
    responsive: [
      {
        breakpoint: 1240,
        settings: {
          arrows: false,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  }

  return (
    <SbEditable content={block}>
      <section className="highlights-block">
        <div className="highlights-block-container">
          <div className="highlights-block-wrapper">
            <div className="row">
              <div className="highlights-block-header">
                <Headline
                  // kicker={@root.name}
                  headline={block.headline}
                  subheadline={block.subheadline}
                />
              </div>
            </div>
            <div className="highlights-block-row">
              <Slider {...settings}>
                {block.highlights?.length > 0 &&
                  block.highlights.map((item, index) => (
                    <div className="highlights-block-highlight" key={index}>
                      <Image
                        image={item.image}
                        alt={item.alt}
                        title={item.alt}
                        imageWidth="460"
                        imageHeight="345"
                      />
                      {item.title?.length > 0 && <h4>{item.title}</h4>}
                      {item.title?.length > 0 && <p>{item.subtitle}</p>}
                      {item.link?.length > 0 && (
                        <Link className="btn btn-primary" link={item.link}>
                          {item.link_text}
                        </Link>
                      )}
                    </div>
                  ))}
              </Slider>
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default HighlightsBlock
